/* Product sidebar presentation. Infinite Options and Shopify retain purchase authority. */
(() => {
  'use strict';
  // Dawn may reinject this asset during a product section swap.
  if (window.wscDefiantSidebarMount) { window.wscDefiantSidebarMount(); return; }
  const ROOT = 'product-info[data-wsc-sidebar-prototype]';
  const profiles = {
    hardware: ['Apple Watch Size', 'Connector Colour', 'Buckle Colour'],
    material: ['Apple Watch Size', 'Connector Colour', 'Strap Material'],
    'connector-diamond': ['Apple Watch Size', 'Connector Colour'],
    diamond: ['Apple Watch Size'], connector: ['Apple Watch Size', 'Connector Colour'],
    size: ['Apple Watch Size'], 'restricted-size': ['Apple Watch Size'],
    'sport-length': ['Watch Size & Band Length'], 'solo-length': ['Watch Size & Band Length']
  };
  const diamondProfiles = new Set(['hardware', 'material', 'connector-diamond', 'diamond']);
  const sizes = [
    '38mm (Apple Watch Series 1, 2 & 3)', '40mm (Apple Watch Series 4, 5, 6, SE & SE 3)',
    '41mm (Apple Watch Series 7, 8 & 9)', '42mm (Apple Watch Series 1, 2 & 3)',
    '44mm (Apple Watch Series 4, 5, 6, SE & SE 3)', '45mm (Apple Watch Series 7, 8 & 9)',
    '42mm (Apple Watch Series 10, 11 & 12)', '46mm (Apple Watch Series 10, 11 & 12)',
    '49mm (Apple Watch Ultra, Ultra 2, Ultra 3 & Ultra 4)'
  ];
  const combinedSize = size => size.replace(' (Apple Watch ', ' [').replace(/\)$/, ']');
  const sameValues = (actual, expected) => actual.length === expected.length && new Set(actual).size === actual.length && actual.every(value => expected.includes(value));
  const splitCombined = value => {
    const match = value.match(/^(\d+mm \[[^\]]+\]) (Small\/Medium|Medium\/Large|Small|Medium|Large)$/);
    return match ? { size: match[1], length: match[2] } : { size: '', length: '' };
  };
  const connector = {
    'Silver Stainless Steel': ['Stainless steel finish', 'Silver', '#c9cbcd'],
    'Jet Black / Space Black Stainless Steel': ['Stainless steel finish', 'Jet Black / Space Black', '#28292b'],
    'Gold Stainless Steel (Series 4 5 10 11 & 12)': ['Stainless steel finish', 'Gold (Series 4, 5, 10, 11, 12)', '#ddc59b'],
    'Gold Stainless Steel (Series 6 7 & 8)': ['Stainless steel finish', 'Gold (Series 6, 7, 8)', '#c9a45f'],
    'Silver Aluminium': ['Aluminium finish', 'Silver', '#dbdcde'],
    'Space Grey Aluminium': ['Aluminium finish', 'Space Grey', '#707174'],
    'Midnight': ['Aluminium finish', 'Midnight', '#293140'],
    'Starlight': ['Aluminium finish', 'Starlight', '#e8dfce'],
    'Rose Gold Aluminium': ['Aluminium finish', 'Rose Gold', '#e8bfaf'],
    'Titanium (Natural)': ['Titanium finish', 'Natural', '#bcb5ab'],
    'Graphite / Slate': ['Titanium finish', 'Graphite / Slate', '#515154'],
    'Edition 18k Gold': ['Edition 18k finish', '18k Gold', '#d7af29'],
    'Edition 18k Rose Gold': ['Edition 18k finish', '18k Rose Gold', '#c59481']
  };
  const buckle = {
    'Stainless Steel - Silver': ['Stainless steel finish', 'Silver', '#c9cbcd'],
    'Stainless Steel - Space Black': ['Stainless steel finish', 'Space Black', '#28292b'],
    'Stainless Steel - 18k Gold': ['Stainless steel finish', '18k Gold', '#d7af29'],
    'Stainless Steel - 18k Rose Gold': ['Stainless steel finish', '18k Rose Gold', '#c59481']
  };
  const controllers = new Map();
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const stepBadge = number => {
    const badge = make('span', 'wsc-ds-step');
    badge.setAttribute('aria-hidden', 'true');
    badge.append(make('span', '', String(number)));
    return badge;
  };
  const choices = select => Array.from(select.options).filter(o => o.value && !/please select|choose|select an option/i.test(o.text));
  const colourDot = colour => {
    const dot = make('span', 'wsc-ds-dot');
    dot.style.backgroundColor = colour;
    dot.setAttribute('aria-hidden', 'true');
    return dot;
  };
  function contract(root) {
    const io = root.querySelector('#infiniteoptions-container');
    if (!io) return null;
    // Empty profile preserves the already-released Defiant during staged asset upload.
    const legacy = !root.hasAttribute('data-wsc-sidebar-profile');
    const profile = legacy ? 'hardware' : root.dataset.wscSidebarProfile;
    const names = profiles[profile];
    if (!names) return null;
    const selects = names.map(name => io.querySelector(`select[name="properties[${name}]"]`));
    if (selects.some(s => !s || s.disabled || (!legacy && !s.required) || !choices(s).length)) return null;
    if (io.querySelectorAll('select').length !== names.length) return null;
    const lengths = profile === 'sport-length' ? ['Small/Medium', 'Medium/Large'] : ['Small', 'Medium', 'Large'];
    for (const select of selects) {
      const name = select.name.slice(11, -1);
      const expected = name === 'Connector Colour' ? Object.keys(connector) : name === 'Buckle Colour' ? Object.keys(buckle) : name === 'Strap Material' ? ['Genuine Leather', 'Vegan Leather'] : name === 'Watch Size & Band Length' ? sizes.flatMap(size => lengths.map(length => `${combinedSize(size)} ${length}`)) : profile === 'restricted-size' ? sizes.filter((_,i) => [0,1,2,6].includes(i)) : sizes;
      if (!sameValues(choices(select).map(o => o.value), expected)) return null;
    }
    const hasDiamond = diamondProfiles.has(profile);
    const radios = Array.from(io.querySelectorAll('input[type="radio"]'));
    if (radios.length !== (hasDiamond ? 2 : 0) || radios.some(r => r.name !== 'properties[Diamond Edition Upgrade]')) return null;
    const no = radios.find(r => r.value === 'No Diamond');
    const yes = radios.find(r => /^Add Diamond: /.test(r.value));
    if (hasDiamond && (!no || !yes)) return null;
    const allowed = new Set([...selects, no, yes]);
    if (Array.from(io.querySelectorAll('input, select, textarea, button')).some(control => !allowed.has(control) && !(control.type === 'hidden' && !control.name.startsWith('properties[')))) return null;
    // Dawn keeps retiring pickers inline-hidden for 500ms after inserting their replacement.
    const nativeSelects = Array.from(root.querySelectorAll('variant-selects'))
      .filter(picker => picker.style.display !== 'none')
      .flatMap(picker => Array.from(picker.querySelectorAll('select')));
    let upgradeMoney = yes?.value.replace('Add Diamond: ', '');
    if (legacy) {
      if (nativeSelects.length !== 1 || nativeSelects[0].options.length !== 2) return null;
    } else {
      let catalogue;
      try { catalogue = JSON.parse(root.querySelector('[data-wsc-sidebar-contract]').textContent); } catch (_) { return null; }
      const variants = catalogue.variants;
      if (!Array.isArray(variants) || catalogue.options?.length !== 1) return null;
      if (hasDiamond) {
        const standard = variants.find(v => v.title === 'No Diamond');
        const upgraded = variants.find(v => v.title === 'Diamond' || v.title === yes.value);
        if (variants.length !== 2 || !standard || !upgraded || !Number.isFinite(standard.price) || !Number.isFinite(upgraded.price) || upgraded.price <= standard.price) return null;
        if (!['Diamond Edition', 'Upgrade to Diamond Edition?'].includes(catalogue.options[0]) || nativeSelects.length !== 1 || !sameValues(Array.from(nativeSelects[0].options).map(o => o.value), variants.map(v => v.title))) return null;
        if (typeof catalogue.upgradeMoney !== 'string' || !catalogue.upgradeMoney.trim()) return null;
        upgradeMoney = catalogue.upgradeMoney.replace(/<[^>]*>/g, '');
      } else if (variants.length !== 1 || variants[0].title !== 'Default Title' || catalogue.options[0] !== 'Title' || nativeSelects.length) return null;
    }
    return { io, selects, no, yes, profile, legacy, upgradeMoney, signature: JSON.stringify([profile, selects.map(s => Array.from(s.options).map(o => [o.value,o.text,o.disabled])), yes?.value, upgradeMoney]) };
  }
  function createController(root) {
    const info = root.querySelector('.product__info-container');
    if (!info) return null;
    let state = null, ui = null, groups = [], diamondButton = null, restoreContent = null, scheduled = false, stopped = false;
    let prices = {}, nativeButtonLabel = null, ownedButtonLabel = null, colourBadge = null, pair = null, writingSource = false;
    try { prices = JSON.parse(root.querySelector('[data-wsc-sidebar-prices]').textContent); } catch (_) { return null; }
    const listen = (target, event, callback) => target.addEventListener(event, callback, { signal: lifetime.signal });
    const lifetime = new AbortController();
    const slot = root.querySelector('[data-wsc-options-slot]');
    const loadingDeadline = slot ? setTimeout(revealNative, 10000) : null;
    function revealNative() {
      if (!slot) return;
      slot.classList.remove('wsc-ds-pending');
      slot.querySelector('.wsc-ds-loading-shell')?.remove();
    }
    function clear() {
      revealNative();
      const button = root.querySelector('product-form button[name="add"]');
      const label = button?.querySelector('span');
      if (label && ownedButtonLabel && label.textContent === ownedButtonLabel && nativeButtonLabel !== null && !button.disabled && !button.classList.contains('loading') && button.getAttribute('aria-disabled') !== 'true') {
        const variant = prices[root.querySelector('product-form input[name="id"]')?.value];
        label.textContent = root.querySelector('[data-wsc-stable-buttons]') && variant?.available
          ? `ADD TO BAG · ${variant.money.replace(/<[^>]*>/g, '')}`
          : nativeButtonLabel;
      }
      nativeButtonLabel = null; ownedButtonLabel = null;
      if (state) state.io.classList.remove('wsc-ds-source');
      if (ui) ui.remove();
      if (colourBadge) colourBadge.remove();
      colourBadge = null;
      if (restoreContent) restoreContent();
      restoreContent = null;
      root.classList.remove('wsc-ds-ready');
      if (root.wscFocusOption === focusOption) delete root.wscFocusOption;
      ui = null; state = null; groups = []; diamondButton = null; pair = null;
    }
    function focusOption(source) {
      const candidates = groups.filter(g => g.source === source);
      const group = candidates.find(g => !g.readValue()) || candidates[0];
      if (!group) return false;
      if (group.details) group.details.open = true;
      group.region.setAttribute('aria-invalid', 'true');
      const first = group.buttons.find(b => !b.disabled);
      if (first) {
        first.focus({ preventScroll: true });
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return !!first;
    }
    function optionButton(option, config, size) {
      const button = make('button', 'wsc-ds-choice');
      button.type = 'button';
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-label', option.text);
      button.dataset.value = option.value;
      button.disabled = option.disabled;
      if (size) {
        const match = option.text.match(/^(\d+mm) \((.*)\)$/);
        button.append(make('strong', '', match[1]), make('span', 'wsc-ds-size-series', match[2].replace(/Apple Watch /g, '').replace(/, Ultra /g, ', ').replace(/ & Ultra /g, ', ')));
      } else if (config) {
        button.append(colourDot(config[2]), make('span', '', config[1]));
      } else {
        button.append(make('span', '', option.text));
      }
      return button;
    }
    function buildGroup(source, kind, step, customOptions, readValue = () => source.value, choose) {
      const size = kind === 'size', config = kind === 'connector' ? connector : kind === 'buckle' ? buckle : null;
      const wrapper = make('section', 'wsc-ds-field');
      const heading = make('div', 'wsc-ds-heading');
      const headingText = make('h2', '', ({size: 'Your Apple Watch', connector: 'Connector colour', buckle: 'Clasp colour', material: 'Strap material', length: 'Strap length'})[kind]);
      headingText.prepend(stepBadge(step));
      headingText.id = `${root.id}-ds-${step}`;
      heading.append(headingText);
      wrapper.append(heading);
      if (size) {
        const help = make('details', 'wsc-ds-help');
        help.append(make('summary', '', 'How to find your size'), make('p', '', 'Check the case size engraved on the back of your Apple Watch. For 42mm, also check the Series in the Watch app under General → About. Choose the tile that matches both.'));
        heading.append(help);
      } else if (kind === 'buckle' && (root.dataset.wscSidebarClaspDetail === 'true' || !root.hasAttribute('data-wsc-sidebar-profile'))) heading.append(make('span', '', '316L stainless steel'));
      const region = make('div', size ? 'wsc-ds-sizes' : config ? 'wsc-ds-colours' : 'wsc-ds-text-choices');
      region.setAttribute('role', 'radiogroup');
      region.setAttribute('aria-labelledby', headingText.id);
      region.setAttribute('aria-required', 'true');
      let details, summaryText, summaryDot, summarySub, summary;
      if (config) {
        details = make('details', 'wsc-ds-disclosure');
        // Open unchosen fields so choices are discoverable, retain collapse after selection.
        details.open = !source.value;
        summary = make('summary', 'wsc-ds-summary');
        summaryDot = colourDot('#eee');
        const copy = make('span');
        summaryText = make('span', 'wsc-ds-summary-label');
        summarySub = make('small');
        copy.append(summaryText, summarySub); summary.append(summaryDot, copy);
        summary.setAttribute('aria-label', kind === 'connector' ? 'Connector colour options' : 'Clasp colour options');
        details.append(summary, region); wrapper.append(details);
      } else wrapper.append(region);
      let options = customOptions || choices(source);
      if (size) {
        // Numeric size order; generation remains part of the original, submitted value.
        options = options.map((option, i) => ({option, i})).sort((a,b) => parseInt(a.option.value) - parseInt(b.option.value) || a.i - b.i).map(x => x.option);
      } else if (config) options = Object.keys(config).map(value => options.find(o => o.value === value)).filter(Boolean);
      const buttons = [];
      let currentFinish;
      options.forEach(option => {
        const itemConfig = config ? config[option.value] : null;
        if (kind === 'connector' && itemConfig[0] !== currentFinish) {
          currentFinish = itemConfig[0];
          region.append(make('p', 'wsc-ds-finish', currentFinish));
        }
        const button = optionButton(option, itemConfig, size);
        button.addEventListener('click', () => {
          if (!source.isConnected || button.disabled) return;
          if (choose) choose(option.value);
          else if (source.value !== option.value) {
            source.value = option.value;
            source.dispatchEvent(new Event('change', { bubbles: true }));
          }
          region.removeAttribute('aria-invalid');
          sync();
        });
        buttons.push(button); region.append(button);
      });
      region.addEventListener('keydown', event => {
        const active = buttons.filter(b => !b.disabled), current = active.indexOf(event.target);
        if (current < 0) return;
        let next;
        if (['ArrowRight','ArrowDown'].includes(event.key)) next = (current + 1) % active.length;
        if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (current - 1 + active.length) % active.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = active.length - 1;
        if (next === undefined) return;
        event.preventDefault(); active[next].focus(); active[next].click();
      });
      return { wrapper, source, buttons, region, details, summaryText, summarySub, summaryDot, summary, config, kind, readValue };
    }
    function moveInformation() {
      const tabs = document.querySelector('.product-tabs');
      const desc = tabs?.querySelector('.product-tabs__desc-text');
      const shipping = tabs?.querySelector('.product-tabs__shipping-layout');
      const faq = tabs?.querySelector('.product-tabs__faq');
      if (!desc || !shipping || !faq) return null;
      const specs = tabs.querySelector('.product-tabs__desc-specs');
      const section = tabs.closest('.shopify-section') || tabs;
      const originalHidden = section.hidden;
      const records = [];
      const accordions = make('div', 'wsc-ds-information');
      let wristAnswer, wristOriginal;
      try {
        [["Description",desc],["Specification",specs],["Delivery and returns",shipping],["Questions",faq]].forEach(([title,node],index) => {
          if (!node || !node.textContent.trim()) return;
          const anchor = document.createComment('WsC sidebar content position');
          node.before(anchor); records.push({node, anchor});
          const detail = make('details', 'wsc-ds-info');
          detail.setAttribute('name', `${root.id}-product-information`);
          detail.open = index === 0;
          const summary = make('summary', '', title);
          // Older engines may ignore details[name]. Close siblings synchronously
          // before native mouse/keyboard activation, avoiding queued toggle races.
          summary.addEventListener('click', () => {
            if (detail.open) return;
            Array.from(accordions.children).forEach(sibling => {
              if (sibling !== detail) sibling.open = false;
            });
          });
          detail.append(summary, node); accordions.append(detail);
        });
        const wristItem = Array.from(faq.querySelectorAll('.product-tabs__faq-item')).find(item => /What size wrists/.test(item.textContent));
        wristAnswer = wristItem?.querySelector('.product-tabs__faq-a');
        if (wristAnswer?.textContent.trim() === 'Once you choose your Apple Watch size above, the recommended wrist sizes will appear in orange.') {
          wristOriginal = wristAnswer.textContent;
          wristAnswer.textContent = 'For help checking the fit before ordering, contact us with your wrist measurement and Apple Watch model.';
        }
        info.append(accordions);
        section.hidden = true;
      } catch (error) {
        records.forEach(({node,anchor}) => { if (anchor.parentNode) anchor.replaceWith(node); });
        section.hidden = originalHidden; accordions.remove(); throw error;
      }
      const restore = () => {
        if (wristAnswer && wristOriginal !== undefined) wristAnswer.textContent = wristOriginal;
        records.forEach(({node,anchor}) => { if (anchor.isConnected) anchor.replaceWith(node); });
        section.hidden = originalHidden;
        accordions.remove();
      };
      restore.source = section;
      return restore;
    }
    function build(next) {
      const panel = make('div', 'wsc-ds-selectors');
      let step = root.querySelector('.wsc-product-colours__label strong') ? 2 : 1;
      const nextGroups = [];
      next.selects.forEach(source => {
        const name = source.name.slice(11, -1);
        if (name === 'Watch Size & Band Length') {
          pair = { source, ...splitCombined(source.value), lastValue: source.value };
          const all = choices(source).map(option => ({option, ...splitCombined(option.value)}));
          const choose = part => value => {
            pair[part] = value;
            if (part === 'size' && pair.length && !all.some(item => item.size === pair.size && item.length === pair.length && !item.option.disabled)) pair.length = '';
            const option = all.find(item => item.size === pair.size && item.length === pair.length && !item.option.disabled)?.option;
            const nativeValue = option?.value || '';
            // Never leave an old valid property behind an incomplete UI selection.
            if (source.value !== nativeValue) {
              source.value = nativeValue;
              pair.lastValue = source.value;
              writingSource = true;
              try { source.dispatchEvent(new Event('change', {bubbles: true})); }
              finally { writingSource = false; }
            }
          };
          ['size', 'length'].forEach(part => {
            const values = [...new Set(all.map(item => item[part]))];
            const options = values.map(value => ({ value, text: part === 'size' ? value.replace(' [', ' (').replace(/\]$/, ')') : value, disabled: all.filter(item => item[part] === value).every(item => item.option.disabled) }));
            nextGroups.push(buildGroup(source, part, step++, options, () => pair[part], choose(part)));
          });
        } else {
          const kind = {'Apple Watch Size':'size', 'Connector Colour':'connector', 'Buckle Colour':'buckle', 'Strap Material':'material'}[name];
          nextGroups.push(buildGroup(source, kind, step++));
        }
      });
      nextGroups.forEach(group => panel.append(group.wrapper));
      let diamond = null;
      if (next.yes) {
      diamond = make('button', 'wsc-ds-diamond');
      diamond.type = 'button'; diamond.setAttribute('role','checkbox');
      diamond.setAttribute('aria-label', 'Add a Diamond');
      const square = make('span', 'wsc-ds-check'); square.setAttribute('aria-hidden','true');
      const diamondCopy = make('span', 'wsc-ds-diamond-copy');
      diamondCopy.append(make('strong','','Add a Diamond'),make('small','', (root.dataset.wscSidebarClaspDetail === 'true' || next.legacy) ? 'VVS+ clarity diamond set in the clasp' : 'VVS+ clarity diamond'));
      diamond.append(square, diamondCopy, make('strong','wsc-ds-upgrade-price',`+${next.upgradeMoney}`));
      diamond.addEventListener('click', () => {
        if (!state || state.yes.disabled || state.no.disabled) return;
        (state.yes.checked ? state.no : state.yes).click();
        sync();
      });
      const diamondField = make('section', 'wsc-ds-field wsc-ds-diamond-field');
      const diamondHeading = make('div', 'wsc-ds-heading');
      const diamondTitle = make('h2', '', 'Diamond Upgrade');
      diamondTitle.prepend(stepBadge(step));
      diamondHeading.append(diamondTitle, make('span', '', 'Optional'));
      diamondField.append(diamondHeading, diamond);
      panel.append(diamondField);
      }
      if (slot && slot.contains(next.io)) {
        slot.prepend(panel);
        revealNative();
        clearTimeout(loadingDeadline);
      } else next.io.before(panel);
      nativeButtonLabel = root.querySelector('product-form button[name="add"] span')?.textContent || null;
      ui = panel; state = next; groups = nextGroups; diamondButton = diamond;
      const colourTitle = root.querySelector('.wsc-product-colours__label strong');
      if (colourTitle && !slot) {
        colourBadge = stepBadge(1);
        colourTitle.prepend(colourBadge);
      }
      restoreContent = moveInformation();
      next.io.classList.add('wsc-ds-source');
      root.classList.add('wsc-ds-ready');
      root.wscFocusOption = focusOption;
      sync();
    }
    function sync() {
      if (!state) return;
      if (pair && pair.source.value !== pair.lastValue) {
        Object.assign(pair, splitCombined(pair.source.value), {lastValue: pair.source.value});
      }
      groups.forEach(group => {
        const selected = group.readValue();
        if (pair && group.kind === 'length') {
          group.buttons.forEach(button => {
            const disabled = !choices(pair.source).some(option => {
              const parts = splitCombined(option.value);
              return !option.disabled && parts.length === button.dataset.value && (!pair.size || parts.size === pair.size);
            });
            if (button.disabled !== disabled) button.disabled = disabled;
          });
        }
        let focusable = group.buttons.find(b => b.dataset.value === selected && !b.disabled) || group.buttons.find(b => !b.disabled);
        group.buttons.forEach(button => {
          button.setAttribute('aria-checked', String(button.dataset.value === selected));
          button.tabIndex = button === focusable ? 0 : -1;
        });
        if (group.summaryText) {
          const item = group.config[group.source.value];
          const text = item ? item[1] : 'Choose a colour';
          const sub = item ? item[0] : 'Select the finish of your watch';
          if (group.summaryText.textContent !== text) group.summaryText.textContent = text;
          if (group.summarySub.textContent !== sub) group.summarySub.textContent = sub;
          group.summaryDot.style.backgroundColor = item ? item[2] : '#eee';
          group.summary.setAttribute('aria-label', `${group.kind === 'connector' ? 'Connector' : 'Clasp'} colour: ${text}, ${sub}`);
        }
      });
      if (diamondButton) {
      diamondButton.setAttribute('aria-checked', String(state.yes.checked));
      const diamondDisabled = state.yes.disabled || state.no.disabled;
      if (diamondButton.disabled !== diamondDisabled) diamondButton.disabled = diamondDisabled;
      }
      syncPrice();
    }
    function syncPrice() {
      if (!state) return;
      const variant = prices[root.querySelector('product-form input[name="id"]')?.value];
      const button = root.querySelector('product-form button[name="add"]');
      if (!variant?.available || !button || button.disabled || button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true') return;
      const label = button.querySelector('span');
      // Keep the actual span cached by Dawn, including its spinner sibling.
      const text = `ADD TO BAG · ${variant.money.replace(/<[^>]*>/g, '')}`;
      ownedButtonLabel = text;
      if (label && label.textContent !== text) label.textContent = text;
      const sticky = document.querySelector('.wsc-sticky-atc__price');
      if (sticky && sticky.textContent !== variant.money) sticky.textContent = variant.money;
    }
    function refresh() {
      if (stopped) return;
      scheduled = false;
      if (!root.isConnected) { destroy(); return; }
      try {
        const next = contract(root);
        // The app can disable a previously selected option after loading. Native
        // required-select validity does not reject a selected disabled option.
        // Clear it so the original purchase guard cannot submit a stale choice.
        next?.selects.forEach(source => {
          if (source.value && !choices(source).some(option => option.value === source.value && !option.disabled)) {
            source.value = '';
            source.dispatchEvent(new Event('change', {bubbles: true}));
          }
        });
        if (state && (!next || next.io !== state.io || next.selects.some((s,i) => s !== state.selects[i]) || next.yes !== state.yes || next.no !== state.no || next.signature !== state.signature || (restoreContent && !restoreContent.source.isConnected))) clear();
        if (next && !state) build(next);
        else if (state) sync();
      } catch (error) {
        clear();
        console.warn('WsC sidebar retained the original option controls.', error);
      }
    }
    function schedule() {
      if (scheduled || stopped) return;
      scheduled = true;
      queueMicrotask(refresh);
    }
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value','disabled','aria-disabled','name','required','data-wsc-sidebar-profile'] });
    // Observe structural section replacement without observing our own style writes.
    const sectionObserver = new MutationObserver(() => {
      if (!root.isConnected || (restoreContent && !restoreContent.source.isConnected)) schedule();
    });
    sectionObserver.observe(document.querySelector('#MainContent') || document.body, {childList:true,subtree:true});
    listen(root, 'change', event => {
      if (pair && event.target === pair.source && !writingSource) Object.assign(pair, splitCombined(pair.source.value), {lastValue: pair.source.value});
      schedule();
    });
    listen(root, 'reset', () => { pair = null; clear(); schedule(); });
    function destroy() {
      if (stopped) return;
      stopped = true;
      clearTimeout(loadingDeadline);
      observer.disconnect(); sectionObserver.disconnect(); lifetime.abort();
      clear(); controllers.delete(root);
    }
    refresh();
    return { destroy };
  }
  function mount() {
    document.querySelectorAll(ROOT).forEach(root => {
      if (!controllers.has(root)) {
        const controller = createController(root);
        if (controller) controllers.set(root, controller);
      }
    });
  }
  window.wscDefiantSidebarMount = mount;
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, root) => {
      if (event.target.contains(root) || event.target.contains(document.querySelector('.product-tabs'))) controller.destroy();
    });
  });
  document.addEventListener('shopify:section:load', mount);
  window.addEventListener('pagehide', () => controllers.forEach(controller => controller.destroy()));
  window.addEventListener('pageshow', mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
})();
